const productCategory = [
    { "name": 'Miscellaneous Services' },
    { "name": 'Civil Works - Others' },
    { "name": 'Civil Works - Roads' },
     { "name": 'Civil Works - Buildings' },
      { "name": 'Civil Works - Water Works' },
    { "name": 'Civil Works' },
    { "name": '  Civil Works - Bridges' },
    { "name": 'Support/Maintenance Service' },
    { "name": 'General Repair Works' },
    { "name": 'Electrical Works' },
    { "name": 'Stationery' },
     { "name": 'Consumables' },
    { "name": 'Electrical Goods/Equipment' },
    { "name": 'Miscellaneous Works' },
    { "name": 'Medicines' },
    { "name": 'Electrical Goods' },
    { "name": 'Consumables - Raw Materials' },
    { "name": 'Support/Maintenance Service' },
    { "name": 'Electrical and Maintenance Works' },
    { "name": 'Security System' },
    { "name": 'Miscellaneous Services' },
    { "name": 'Housekeeping/ Cleaning' },
    { "name": 'Survey' },
    { "name": 'Consultancy' },
    { "name": 'Scanning, Digitisation Services' },
    { "name": 'Laboratory and scientific equipment' },    
    { "name": 'Consumables' },    
      { "name": 'Farm Machinery and Equipments' },
       { "name": 'Land/Building' },                 
        { "name": 'Information Technology' },
         { "name": 'Agricultural or Forestry' },
          { "name": 'Laboratory and scientific equipment' },
           { "name": 'Farm Machinery and Equipments' },
            { "name": 'Electrical Goods/Equipment' },
                  { "name": 'Sanitory Works' },
                     { "name": 'Support/Maintenance Service' },
                     { "name": 'General Repair Works' },
                     { "name": 'Electrical and Maintenance Works' },
                        { "name": 'Chemicals/Minerals' },
                      { "name": ' Hiring of Goods' },
                      { "name": ' Solid Waste Management' },
  { "name": 'Consumables - Raw Materials' },
   { "name": ' Advertisement Services' },
      { "name": 'Food Products' },     
        { "name": 'Electrical Goods/Equipment' },    
        { "name": 'Pumps/Motors' }, 
         { "name": 'Civil Works - Lift Irrigation Schemes' }, 
          { "name": ' General Repair Works' }, 
    ];
export default productCategory;
